import { render } from "./NavigationTabs.vue?vue&type=template&id=e9dcc2b8&scoped=true"
import script from "./NavigationTabs.vue?vue&type=script&lang=js"
export * from "./NavigationTabs.vue?vue&type=script&lang=js"

import "./NavigationTabs.vue?vue&type=style&index=0&id=e9dcc2b8&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9dcc2b8"]])

export default __exports__